module.exports = __webpack_public_path__ + "img/edit.084d1a52.svg";